// Descriptor concreti dei provider mail. Ogni provider mappa il proprio store
// e drawer store sull'interfaccia MailProviderValue consumata dai componenti
// condivisi (Google=Gmail, Microsoft=Outlook).
import { useGmailStore } from '../../lib/stores/gmailStore';
import { useGmailDrawerStore } from '../../lib/stores/gmailDrawerStore';
import { useOutlookStore } from '../../lib/stores/outlookStore';
import { useOutlookDrawerStore } from '../../lib/stores/outlookDrawerStore';
import type { MailProviderValue } from './MailProviderContext';

export const googleMailProvider: MailProviderValue = {
  provider: 'google',
  displayName: 'Gmail',
  useStore: useGmailStore,
  useDrawerStore: useGmailDrawerStore,
};

export const microsoftMailProvider: MailProviderValue = {
  provider: 'microsoft',
  displayName: 'Outlook',
  useStore: useOutlookStore,
  useDrawerStore: useOutlookDrawerStore,
};
